import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import AuthService from 'services/Auth';
import routeCodes from 'common/constants/route-codes';
import * as types from './types';

import {
  loginUserRequest,
  resetSignInErrors,
  resetPassword,
  resetPasswordResetErrors,
  getAuthUserAction,
  signupRequest,
  confirmPhoneRequest,
  changeEmailRequest,
  changePhoneRequest,
} from './actions';
import {
  signInErrorsSelector,
  signInInProcessSelector,
  resetPasswordErrorsSelector,
  resetPasswordInProcessSelector,
  userDataSelector,
  isSuperAdminSelector,
  getInProcessSelector,
} from './selectors';
import { RESET_STORE } from '../common/types';

export const useUser = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const signInInProcess = useSelector(signInInProcessSelector);
  const signInErrors = useSelector(signInErrorsSelector);
  const resetPasswordErrors = useSelector(resetPasswordErrorsSelector);
  const resetPasswordInProcess = useSelector(resetPasswordInProcessSelector);
  const isSuperAdmin = useSelector(isSuperAdminSelector);
  const getInProcess = useSelector(getInProcessSelector);
  const userData = useSelector(userDataSelector);

  function handleSignIn(payload) {
    dispatch(loginUserRequest({ data: payload, history }));
  }

  function resetErrors() {
    if (signInErrors) {
      dispatch(resetSignInErrors());
    }
    if (resetPasswordErrors) {
      dispatch(resetPasswordResetErrors());
    }
  }

  function getAuthUser(pathname) {
    dispatch(getAuthUserAction({ history, pathname }));
  }

  function handleLogout() {
    AuthService.logout();
    history.push(routeCodes.signIn);
    dispatch({
      type: RESET_STORE,
    });
  }

  function handleResetPassword(payload) {
    dispatch(resetPassword({ data: payload, history }));
  }

  function sendResetPassword(payload) {
    console.log('sendResetPassword', payload);
    dispatch({
      type: 'USER_SEND_RESET_PASSWORD_REQUEST',
      payload: payload,
    });
  }

  function handleSignup(payload) {
    return new Promise((resolve, reject) => {
      const action = {
        type: types.USER_SIGNUP_REQUEST,
        payload: { data: payload },
      };

      action.meta = {
        resolve: (result) => {
          if (result.error) {
            reject(result.error);
          } else {
            resolve(result);
          }
        },
        reject,
      };

      dispatch(action);
    });
  }

  function handleConfirmPhone(payload) {
    return new Promise((resolve, reject) => {
      const action = {
        type: types.USER_CONFIRM_PHONE_REQUEST,
        payload: { data: payload },
        meta: {
          resolve: (result) => {
            if (result.error) {
              reject(result.error);
            } else {
              resolve(result);
            }
          },
          reject,
        },
      };
      dispatch(action);
    });
  }

  function handleChangeEmail(payload) {
    dispatch(changeEmailRequest({ data: payload }));
  }

  function handleChangePhone(payload) {
    return new Promise((resolve, reject) => {
      const action = {
        type: types.USER_CHANGE_PHONE_REQUEST,
        payload: { data: payload },
        meta: {
          resolve: (result) => {
            if (result.error) {
              reject(result.error);
            } else {
              resolve(result);
            }
          },
          reject,
        },
      };

      dispatch(action);
    });
  }
  function hendleResendPhoneCode(payload) {
    return new Promise((resolve, reject) => {
      const action = {
        type: types.USER_RESEND_PHONE_CODE_REQUEST,
        payload: { data: payload },
        meta: {
          resolve: (result) => {
            if (result.error) {
              reject(result.error);
            } else {
              resolve(result);
            }
          },
          reject,
        },
      };

      dispatch(action);
    });
  }
  function hendleResendEmailCode(payload) {
    return new Promise((resolve, reject) => {
      const action = {
        type: types.USER_RESEND_EMAIL_CODE_REQUEST,
        payload: { data: payload },
        meta: {
          resolve: (result) => {
            if (result.error) {
              reject(result.error);
            } else {
              resolve(result);
            }
          },
          reject,
        },
      };

      dispatch(action);
    });
  }
  function handleConfirmEmail(payload) {
    return new Promise((resolve, reject) => {
      const action = {
        type: types.USER_CONFIRM_EMAIL_REQUEST,
        payload: { data: payload },
        meta: {
          resolve: (result) => {
            if (result.error) {
              reject(result.error);
            } else {
              resolve(result);
            }
          },
          reject,
        },
      };

      dispatch(action);
    });
  }

  return {
    handleSignIn,
    handleLogout,
    signInInProcess,
    signInErrors,
    resetErrors,
    handleResetPassword,
    resetPasswordErrors,
    resetPasswordInProcess,
    userData,
    getAuthUser,
    isSuperAdmin,
    getInProcess,
    sendResetPassword,
    handleSignup,
    handleConfirmPhone,
    handleChangeEmail,
    handleChangePhone,
    hendleResendPhoneCode,
    hendleResendEmailCode,
    handleConfirmEmail,
  };
};
